/* PrimeBuild – aviso de carrito (mini carrito arriba a la derecha) + PRIME30. 2026-10-13
   - Escucha el evento 'cart:update' del tema (Horizon) al añadir desde el formulario de producto,
     la barra fija de móvil o la compra rápida.
   - Muestra: producto añadido, nº de artículos, subtotal, botones "View cart" y "Checkout".
   - Si en el carrito hay productos PRIME30 (y aún no ha pasado el 30-nov 04:59 UTC): franja + fila de productos.
   - Mantiene al día el número del icono del carrito de la cabecera PrimeBuild.
   - Botones "Add" de PRIME30 (popup y página del carrito) añaden por /cart/add.js. */
(function () {
  if (window.__pbpCartNotify) return;
  window.__pbpCartNotify = true;

  function readJSON(id) {
    var el = document.getElementById(id);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  var cfg = readJSON('pbp-cn-config') || { cartUrl: '/cart', checkoutUrl: '/checkout', money: '${{amount}}' };
  var p30 = readJSON('pbp-p30-data');
  function p30Active() {
    var end = p30 ? Date.parse(p30.end) : NaN;
    return !!(p30 && p30.products && p30.products.length && !isNaN(end) && Date.now() < end);
  }

  // Ocultar franjas PRIME30 servidas desde caché tras la fecha de fin
  document.querySelectorAll('[data-pbp-p30-end]').forEach(function (el) {
    var end = Date.parse(el.getAttribute('data-pbp-p30-end'));
    if (!isNaN(end) && Date.now() >= end) el.remove();
  });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var v = (Number(cents) || 0) / 100;
    var amount = v.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var fmt = cfg.money || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, amount).replace(/<[^>]*>/g, '');
  }
  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function updateHeaderCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('a[aria-label="Cart"][class*="pb-icon-link-"]').forEach(function (link) {
      var badge = link.querySelector('[class*="pb-cart-count-"]');
      if (!badge && count > 0) {
        var m = (link.className.match(/pb-icon-link-([^\s]+)/) || [])[1];
        if (!m) return;
        badge = document.createElement('span');
        badge.className = 'pb-cart-count-' + m;
        link.appendChild(badge);
      }
      if (!badge) return;
      if (count > 0) { badge.textContent = count; badge.hidden = false; } else { badge.hidden = true; }
    });
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function p30Applied(cart) {
    if (/(?:^|;\s*)discount_code=PRIME30(?:;|$)/i.test(document.cookie)) return true;
    var apps = (cart && cart.cart_level_discount_applications) || [];
    if (apps.some(function (a) { return (a.title || '').toUpperCase() === 'PRIME30'; })) return true;
    return ((cart && cart.items) || []).some(function (i) {
      return (i.line_level_discount_allocations || []).some(function (d) {
        return d.discount_application && (d.discount_application.title || '').toUpperCase() === 'PRIME30';
      });
    });
  }

  function p30Html(cart) {
    if (!p30Active() || !cart || !cart.items) return '';
    var handles = p30.products.map(function (p) { return p.handle; });
    var inCart = cart.items.map(function (i) { return i.handle; });
    var hasOne = inCart.some(function (h) { return handles.indexOf(h) > -1; });
    if (!hasOne) return '';
    var others = p30.products.filter(function (p) { return inCart.indexOf(p.handle) === -1; });
    var applied = p30Applied(cart);
    var h = '<div class="pbp-p30 pbp-p30--popup">' +
      '<div class="pbp-p30__banner"><p class="pbp-p30__msg"><strong>30% OFF</strong> these featured products — no code needed, until Nov 29</p>' +
      '<span class="pbp-p30__ok">Discount applied</span>' +
      '</div>';
    if (others.length) {
      h += '<div class="pbp-p30__row"><p class="pbp-p30__heading">Add more at 30% off</p><ul class="pbp-p30__list" role="list">';
      others.forEach(function (p) {
        h += '<li class="pbp-p30__card">' +
          '<a class="pbp-p30__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<a class="pbp-p30__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="pbp-p30__price">' + (p.from ? 'From ' : '') + esc(p.price) + '</span>' +
          (p.single ? '<button type="button" class="pbp-p30__add" data-pbp-p30-add="' + esc(p.variant) + '">Add</button>'
                    : '<a class="pbp-p30__add" href="' + esc(p.url) + '">Choose</a>') +
          '</li>';
      });
      h += '</ul></div>';
    }
    return h + '</div>';
  }

  var panel, timer;
  function hide() {
    if (!panel) return;
    panel.classList.remove('is-visible');
    panel.setAttribute('aria-hidden', 'true');
  }
  function show(cart, variantId) {
    if (!panel) {
      panel = document.createElement('div');
      panel.className = 'pbp-cn';
      panel.setAttribute('role', 'dialog');
      panel.setAttribute('aria-label', 'Added to cart');
      document.body.appendChild(panel);
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
      panel.addEventListener('focusin', function () { clearTimeout(timer); });
      panel.addEventListener('touchstart', function () { clearTimeout(timer); }, { passive: true });
      panel.addEventListener('scroll', function () { clearTimeout(timer); }, { passive: true });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
      document.addEventListener('click', function (e) {
        if (panel.classList.contains('is-visible') && !panel.contains(e.target) && !e.target.closest('product-form-component, sticky-add-to-cart, .add-to-cart-button')) hide();
      });
    }
    var item = null;
    if (cart && cart.items) {
      item = cart.items.find(function (i) { return String(i.variant_id) === String(variantId) || String(i.id) === String(variantId); }) || cart.items[0];
    }
    var count = cart ? cart.item_count : 0;
    var h = '<div class="pbp-cn__head"><span class="pbp-cn__check" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 8.5l3.2 3L13 4.5"/></svg></span>' +
      '<strong>Added to cart</strong>' +
      '<button type="button" class="pbp-cn__close" aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg></button></div>';
    if (item) {
      h += '<div class="pbp-cn__item">' +
        (item.image ? '<img class="pbp-cn__img" src="' + esc(img(item.image, 160)) + '" alt="" width="64" height="64">' : '') +
        '<div class="pbp-cn__info"><p class="pbp-cn__name">' + esc(item.product_title) + '</p>' +
        (item.variant_title ? '<p class="pbp-cn__var">' + esc(item.variant_title) + '</p>' : '') +
        '<p class="pbp-cn__qty">Qty ' + esc(item.quantity) + ' · ' + esc(money(item.final_line_price)) + '</p></div></div>';
    }
    h += '<div class="pbp-cn__sum"><span>Cart: ' + count + (count === 1 ? ' item' : ' items') + '</span><span>Subtotal <strong>' + esc(money(cart ? cart.total_price : 0)) + '</strong></span></div>' +
      '<p class="pbp-cn__note">Shipping and taxes are shown at checkout before you pay.</p>' +
      '<div class="pbp-cn__actions"><a class="pbp-cn__view" href="' + esc(cfg.cartUrl || '/cart') + '">View cart</a>' +
      '<a class="pbp-cn__checkout" href="' + esc(cfg.checkoutUrl || '/checkout') + '">Checkout</a></div>' +
      p30Html(cart);
    panel.innerHTML = h;
    panel.querySelector('.pbp-cn__close').addEventListener('click', hide);
    var hg = document.getElementById('header-group');
    var bottom = hg ? Math.max(0, hg.getBoundingClientRect().bottom) : 0;
    panel.style.top = Math.round(bottom + 8) + 'px';
    panel.removeAttribute('aria-hidden');
    requestAnimationFrame(function () { panel.classList.add('is-visible'); });
    clearTimeout(timer);
    timer = setTimeout(hide, panel.querySelector('.pbp-p30') ? 15000 : 9000);
  }

  // Evento del tema al añadir / cambiar el carrito
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail;
    if (!d) return;
    var cart = d.resource;
    if (cart && typeof cart.item_count === 'number') updateHeaderCount(cart.item_count);
    if (!d.data || d.data.source !== 'product-form-component' || d.data.didError) return;
    var vid = d.sourceId;
    if (cart && cart.items && typeof cart.total_price === 'number') show(cart, vid);
    else getCart().then(function (c) { updateHeaderCount(c.item_count); show(c, vid); }).catch(function () {});
  });

  // Botones "Add" de PRIME30 (popup y página del carrito)
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pbp-p30-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var id = btn.getAttribute('data-pbp-p30-add');
    btn.disabled = true;
    var label = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        if (cfg.isCart) { window.location.reload(); return; }
        return getCart().then(function (c) { updateHeaderCount(c.item_count); show(c, id); });
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });
})();
